import { defineComponent as _defineComponent } from 'vue'
import BeneficiaryListing from './BeneficiaryListing.vue';
import { selectableBeneficiaryTableFields } from '../models/beneficiaryTableFields';
import BeneficiaryEditModal from './BeneficiaryEditModal.vue';
import { AuthorityType, Beneficiary, BeneficiaryCategory, BeneficiaryStatus } from 'ah-api-gateways';
import { computed, reactive, ref, watch } from 'vue';
import { useAhBeneficiariesState } from '..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'BeneficiaryAccountSelector',
  props: {
    allowedCurrencies: null,
    allowedBankingSchemes: null,
    allowedStatuses: { default: () => [BeneficiaryStatus.APPROVED] },
    beneficiary: null,
    beneficiaryQuery: { default: '' }
  },
  emits: ["update:beneficiary", "update:beneficiaryQuery"],
  setup(__props: any, { expose, emit }: { emit: ({
  /**
   * - 'update:beneficiary': payload with beneficiary
   */
  (e: 'update:beneficiary', value: Beneficiary | null | undefined): void;
  /**
   * 'update:beneficiaryQuery' for prop update (and handling query externally)
   */
  (e: 'update:beneficiaryQuery', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { allowedCurrencies?: string[], allowedBankingSchemes?: string[], allowedStatuses: BeneficiaryStatus[], beneficiary?: Beneficiary | null, beneficiaryQuery: string };

const beneficiaryListing = ref<InstanceType<typeof BeneficiaryListing> | null>(null);



const onBehalfOfClient = useOnBehalfOf();



const state = reactive({
  searchQuery: '',
  selectedBeneficiary: null as Beneficiary | null,
});

const beneficiarieState = useAhBeneficiariesState();

const canManageBeneficiaries = computed(() => {
  return (
    onBehalfOfClient.value || beneficiarieState.store.useAuthStore().hasAuthorities(AuthorityType.MANAGE_BENEFICIARIES)
  );
});

const isClient = computed(() => {
  return beneficiarieState.store.useAuthStore().isClientUser || !!onBehalfOfClient.value;
});

const filter = computed(() => {
  return {
    query: state.searchQuery,
    category: isClient.value ? BeneficiaryCategory.CLIENT_3RD_PARTY : BeneficiaryCategory.PARTNER_3RD_PARTY,
    status: props.allowedStatuses,
  };
});

const beneficiaryTableConfig = computed(() => {
  return {
    tableFields: selectableBeneficiaryTableFields,
  };
});

const beneficiaryId = computed(() => {
  return state.selectedBeneficiary?.id ?? undefined;
});

function onBeneficiaryAdded(beneficiary?: Beneficiary) {
  beneficiaryListing.value?.loadData().then((data) => {
    if (beneficiary) {
      const item = data.list.find((i) => i.id === beneficiary.id);
      if (item) {
        beneficiaryListing.value!.openItem(item);
      }
    }
  });
}

function selectBeneficiary(beneficiary?: Beneficiary | null) {
  emit('update:beneficiary', beneficiary);
}

function rowClicked(beneficiary?: Beneficiary | null) {
  state.selectedBeneficiary = beneficiary ?? null;
  selectBeneficiary(beneficiary);
}

watch(
  () => props.beneficiary,
  () => {
    rowClicked(props.beneficiary);
  },
  { immediate: true }
);

watch(
  () => props.beneficiaryQuery,
  () => {
    if (props.beneficiaryQuery !== state.searchQuery) {
      state.searchQuery = props.beneficiaryQuery;
    }
  },
  { immediate: true }
);

watch(
  () => props.allowedCurrencies,
  () => {
    if (props.allowedCurrencies && props.beneficiary && !props.allowedCurrencies.includes(props.beneficiary.currency)) {
      selectBeneficiary(null);
    }
  },
  { immediate: true }
);

watch(
  () => props.allowedBankingSchemes,
  () => {
    if (
      props.allowedBankingSchemes &&
      props.beneficiary &&
      !props.allowedBankingSchemes.includes(props.beneficiary.currency)
    ) {
      selectBeneficiary(null);
    }
  },
  { immediate: true }
);

expose({ onBeneficiaryAdded });

return { __sfc: true,beneficiaryListing, emit, onBehalfOfClient, props, state, beneficiarieState, canManageBeneficiaries, isClient, filter, beneficiaryTableConfig, beneficiaryId, onBeneficiaryAdded, selectBeneficiary, rowClicked, BeneficiaryListing, BeneficiaryEditModal }
}

})